module.exports = __webpack_public_path__ + "img/371.9df96fdf.jpg";